import React from 'react';
import { motion, AnimatePresence } from 'motion/react';

interface LoadingOverlayProps {
  isLoading: boolean;
  message?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading, message = "Processing, please wait..." }) => {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#fffaf7]/60 backdrop-blur-sm"
        >
          <style>
            {`
              .pen-anim { animation: write 2.5s infinite ease-in-out; }
              @keyframes write {
                0% { transform: translate(0, 0); }
                15% { transform: translate(35px, -10px); }
                30% { transform: translate(-10px, 15px); }
                45% { transform: translate(25px, 5px); }
                60% { transform: translate(-10px, 30px); }
                75% { transform: translate(25px, 20px); }
                100% { transform: translate(0, 0); }
              }
              .writing-line-1 { animation: draw-line 2.5s infinite; }
              .writing-line-2 { animation: draw-line 2.5s infinite; animation-delay: 0.8s; }
              .writing-line-3 { animation: draw-line 2.5s infinite; animation-delay: 1.6s; }
              @keyframes draw-line {
                0%, 10% { stroke-dashoffset: 40; }
                30%, 100% { stroke-dashoffset: 0; }
              }
            `}
          </style>
          <svg width="120" height="120" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M40 130 C 40 130, 90 150, 100 130 C 110 150, 160 130, 160 130 L 160 70 C 160 70, 110 90, 100 70 C 90 90, 40 70, 40 70 Z" fill="white" stroke="#ea580c" strokeWidth="8" strokeLinejoin="round"/>
            <path d="M100 70 L 100 130" stroke="#ea580c" strokeWidth="8" strokeLinecap="round"/>
            <path d="M55 85 Q 80 95 90 85" stroke="#cbd5e1" strokeWidth="4" strokeLinecap="round"/>
            <path d="M55 100 Q 80 110 90 100" stroke="#cbd5e1" strokeWidth="4" strokeLinecap="round"/>
            <path d="M55 115 Q 80 125 90 115" stroke="#cbd5e1" strokeWidth="4" strokeLinecap="round"/>
            <path className="writing-line-1" d="M110 85 Q 120 95 145 85" stroke="#1e293b" strokeWidth="4" strokeLinecap="round" strokeDasharray="40" strokeDashoffset="40"/>
            <path className="writing-line-2" d="M110 100 Q 120 110 145 100" stroke="#1e293b" strokeWidth="4" strokeLinecap="round" strokeDasharray="40" strokeDashoffset="40"/>
            <path className="writing-line-3" d="M110 115 Q 120 125 145 115" stroke="#1e293b" strokeWidth="4" strokeLinecap="round" strokeDasharray="40" strokeDashoffset="40"/>
            <g className="pen-anim">
              <path d="M160 20 L 175 35 L 135 75 L 120 60 Z" fill="#ea580c" stroke="#1e293b" strokeWidth="4" strokeLinejoin="round"/>
              <path d="M120 60 L 135 75 L 110 85 Z" fill="#1e293b" stroke="#1e293b" strokeWidth="4" strokeLinejoin="round"/>
              <path d="M160 20 L 175 35 L 185 25 L 170 10 Z" fill="#1e293b" stroke="#1e293b" strokeWidth="4" strokeLinejoin="round"/>
            </g>
          </svg>
          <p className="mt-6 font-black text-orange-600 tracking-widest text-lg animate-pulse">{message}</p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
